export default __webpack_public_path__ + "static/media/journey_sl_results.83d8d2c8.png";